import React from 'react';
import { Col, FormGroup, Checkbox } from 'react-bootstrap';

export const Buckets = [
  'Inbox',
  '1st Wave VIP',
  '1st Wave Trending',
  '1st Wave Standard',
  '2nd Wave',
  '3rd Wave',
  'Not Sure',
  'Pass'
]

class BucketFilters extends React.Component {
  updateBucket(e){
    const bucket = e.target.name;
    const checked = e.target.checked;

    if(checked){
      this.props.addBucket(bucket);
    } else {
      this.props.removeBucket(bucket);
    }
  }
  render(){
    const self = this;
    return(
      <Col md={6}>
        <label className="control-label">Buckets</label>
        <FormGroup>
          {
            Buckets.map(function(bucket){
              return(
                <Checkbox
                  key={bucket}
                  name={bucket}
                  checked={self.props.selectedBuckets.includes(bucket)}
                  inline
                  onChange={self.updateBucket.bind(self)}
                >
                  {bucket}
                </Checkbox>
              )
            })
          }
        </FormGroup>
      </Col>
    )
  }
}

export default BucketFilters;
